import {ComponentProps, FC} from 'react';

export const IconCrossedOutDone: FC<ComponentProps<'svg'>> = ({
    fill = 'var(--color-icon-primary)',
    ...rest
}) => {
    return (
        <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...rest}
        >
            <path
                d="M8.24531 4.81531L6.79531 3.35531C8.37531 2.30531 10.2653 1.69531 12.3053 1.69531C17.8253 1.69531 22.3053 6.17531 22.3053 11.6953C22.3053 13.7353 21.6953 15.6253 20.6453 17.2053L19.1853 15.7453C19.8953 14.5553 20.3053 13.1753 20.3053 11.6953C20.3053 7.28531 16.7153 3.69531 12.3053 3.69531C10.8253 3.69531 9.44531 4.10531 8.24531 4.81531ZM17.9653 9.22531L16.5553 7.81531L13.9053 10.4653L15.3153 11.8753L17.9653 9.22531ZM20.0853 22.3053L17.8153 20.0353C16.2353 21.0853 14.3453 21.6953 12.3053 21.6953C6.78531 21.6953 2.30531 17.2153 2.30531 11.6953C2.30531 9.65531 2.91531 7.76531 3.96531 6.18531L1.69531 3.91531L3.10531 2.50531L21.4853 20.8853L20.0853 22.3053ZM16.3653 18.5753L12.4853 14.6953L10.8953 16.2853L6.65531 12.0453L8.06531 10.6353L10.8953 13.4653L11.0753 13.2853L5.42531 7.63531C4.71531 8.83531 4.30531 10.2153 4.30531 11.6953C4.30531 16.1053 7.89531 19.6953 12.3053 19.6953C13.7853 19.6953 15.1653 19.2853 16.3653 18.5753Z"
                fill={fill}
            />
        </svg>
    );
};
